import { Component, inject, signal } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { Report } from '../../../shared/models/scheduled-task.model';
import { SchedulerService } from '../../../shared/services/scheduler.service';

@Component({
  standalone: false,
  selector: 'app-appscripts-user-table-actions',
  templateUrl: './scheduler-reports-table-actions.component.html',
  styleUrls: ['./scheduler-reports-table-actions.component.scss'],
})
export class SchedulerReportsTableActionsComponent {
  currentRow = signal<Report>(null);

  schedulerService = inject(SchedulerService);

  agInit(params: ICellRendererParams): void {
    this.currentRow.set(params.data);
  }

  refresh() {
    return true;
  }

  onClick(clickedItem: string) {
    this.schedulerService.announceReportAction({ name: clickedItem, row: this.currentRow(), column: 'action' });
  }
}
